import React, { Children } from 'react';
import { css } from '@linaria/atomic';
import type { BasicFormFieldProps } from '../../layouts';
import { RadioFieldLayout } from '../../layouts';
import { OptionSwitchOption } from './option-switch-option.component';

const optionSwitchFieldDivStyle1 = css`
  height: 40px;
  display: flex;

  button {
    flex-basis: var(--option-switch-flex-basis);
  }

  button[aria-checked='true'] + button {
    border-left: 0;
  }
`;

type Props = Omit<BasicFormFieldProps<'radio'>, 'label'> & {
  children: Array<React.ReactElement | null>;
  label?: string;
};

export const OptionSwitchField = ({ children, ...rest }: Props) => {
  const childCount = Children.toArray(children).length;
  return (
    <RadioFieldLayout {...rest}>
      <div
        className={optionSwitchFieldDivStyle1}
        style={{ '--option-switch-flex-basis': `${100 / childCount}%` } as React.CSSProperties}
      >
        {children}
      </div>
    </RadioFieldLayout>
  );
};

OptionSwitchField.Option = OptionSwitchOption;
